export const objectEntriesToUrlParams = (
  object: Record<string, unknown>
): string => {
  return Object.entries(object).reduce(
    (paramsString: string, [key, value], index) => {
      const separator = index === 0 ? "?" : "&";
      return (paramsString += `${separator}${key}=${value}`);
    },
    ""
  );
};

export const objectEntriesToBServerJUrl = (
    object: Record<string, unknown>,
    numberOfAds: number,
): string => {
    let params =  Object.entries(object).reduce(
        (paramsString: string, [key, value], index) => {
            return key ==='SIZE' ? paramsString : (`${paramsString}/${key}=${value}`);
        },
        ""
    );

    for (let index = 1; index <= numberOfAds; index++) {
        params = `${params}/b${index}/SIZE=${object.SIZE}`;
    }

    return params;
};
